<div class="headerFlexW pr-4 m-3">
    <div class="content-block">
        <p class="bread-crumbs"> Common Material Group / Nuevo CMG</p>
        <h2 class="">CMG</h2>
    </div>
    <dx-button text="Nuevo CMG" icon="plus" type="default" (onClick)="addCMG()"></dx-button>
</div>

<div class="content-block">
    <div class="dx-card responsive-paddings">
        <h2>Common Material Group</h2>
        <dx-data-grid [dataSource]="requests" keyExpr="cmgId" [showBorders]="true">
            <dxo-search-panel [visible]="true" [width]="240" placeholder="Buscar..."></dxo-search-panel>
            <dxo-load-panel [enabled]="true"></dxo-load-panel>
            <dxo-paging [pageSize]="10"></dxo-paging>
            <dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[5, 10, 25, 50, 100]" [showInfo]="true">
            </dxo-pager>
            <dxi-column dataField="cmgCode" caption="CMG" alignment="center">
            </dxi-column>
            <dxi-column dataField="cmgName" caption="Name" alignment="center">
            </dxi-column>
            <dxi-column dataField="category" caption="Category" alignment="center">
            </dxi-column>
            <dxi-column dataField="department" caption="department" alignment="center">
            </dxi-column>
            <dxi-column dataField="cmgId" caption="Editar" cellTemplate="deleteTemplate"></dxi-column>
            <div *dxTemplate="let d of 'deleteTemplate'">
                <div> 
                    <dx-button id="deleteButton" icon="fas fa-trash ico-sm" (onClick)="onDeleteCMG(d.value)" ngClass="danger-Color"></dx-button>
                </div>
            </div>
            <dxi-column dataField="cmgId" caption="Editar" cellTemplate="editTemplate"></dxi-column>
            <div *dxTemplate="let d of 'editTemplate'">
                <div> 
                    <dx-button icon="fas fa-pencil ico-sm" (onClick)="editCMG(d.value)" class="brand-color"></dx-button>
                </div>
            </div>
        </dx-data-grid>
    </div>
</div>